module.exports = __webpack_public_path__ + "img/location.c4688f91.png";